import { AxiosResponse } from "axios";
import { RequestType } from "../../types/requests";
import { createServiceCoordinator } from "zeus-front-utils";
import { getLocalStorageUserSession } from "../secureStorage";

export const service = async <T>(request: RequestType) => {
  try {
    const res = (await getLocalStorageUserSession()) as { data?: any };

    const { data } = res;

    if (!data) throw new Error("No session data");

    const {
      access_token: accessToken,
      public_key: publicKey,
      refresh_token: refreshToken,
      username,
    } = data.tokens;

    return createServiceCoordinator({
      username,
      accessToken,
      refreshToken,
      publicKey,
    })(request) as Promise<AxiosResponse<T, any>>;
  } catch (e) {
    throw new Error("No keys founded");
  }
};
